import { render } from "./GlobalNewOneOnOneDialogHOC.vue?vue&type=template&id=46773716"
import script from "./GlobalNewOneOnOneDialogHOC.vue?vue&type=script&lang=js"
export * from "./GlobalNewOneOnOneDialogHOC.vue?vue&type=script&lang=js"
script.render = render

export default script